import { CreateOrUpdateProductWithBusiness, CreateProductWithBusiness, ProductWithBusinessToList, UpdateProductWithBusiness } from '@/entities/businessProduct';
import { BusinessProductService } from '@/services/BusinessProductService';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export function useProductWithBusiness(){
  const leadId = Number(useParams().leadId);
  const [productsWithBusiness, setProductsWithBusiness] = useState([]);
  const [productsBusiness, setProductsBusiness] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState<ProductWithBusinessToList[] | []>([]);
  const [product2Edit, setProduct2Edit] = useState<ProductWithBusinessToList>();
  const [openEdit, setOpenEdit] = useState(false);
  
  useEffect(()=>{
    fetchBusinessProduct();
    fetchBusinessProductWithId(leadId);
  },[leadId]);

  useEffect(()=>{
    // console.log(productsWithBusiness);
  },[productsWithBusiness]);

  const fetchBusinessProductWithId = async (businessId: number) => {
    const response = await BusinessProductService.getBusinessProduct(businessId);
    if(response){
      setProductsWithBusiness(response);
      return response;
    }      
  };

  const fetchBusinessProduct = async () => {
    const response = await BusinessProductService.getAllBusinessProduct();
    if(response){
      setProductsBusiness(response);
      return response;
    }
  };

  const createBusinessProduct = async (businessProduct:CreateProductWithBusiness) => {
    // console.log(businessProduct);
    try{
      const response = await BusinessProductService.createBusinessProduct(businessProduct);
      if(response){
        return response;
      }
    }catch(error){
      console.error('Deu ruim, meu chapa ', error);
    }
  };

  const updateBusinessProduct = async (businessProduct:UpdateProductWithBusiness) => {
    const response = await BusinessProductService.updateBusinessProduct(businessProduct);
    if(response){
      return response;
    }
  };

  const getInfosBusinessProduct = async (businessProductId: number) => {
    const response = await BusinessProductService.getInfosBusinessProduct(Number(businessProductId));
    if(response){
      return response;
    }
  }

  const createOrUpdateProductWithBusiness = async (productBusiness:CreateOrUpdateProductWithBusiness) => {
    const response = await BusinessProductService.updateOrCreateBusinessProduct(productBusiness);
    // console.log(response);
    if(response){
      return response;
    }
  };

  const deleteBusinessProduct = async (id:number) => {
    try{
      const response = await BusinessProductService.deleteBusinessProduct(id);
      if(response){
        return response;
      }
    }catch(error){
      console.error('Deu ruim, meu chapa ', error);
    }
  };

  return {
    getInfosBusinessProduct,
    fetchBusinessProductWithId,
    createOrUpdateProductWithBusiness,
    fetchBusinessProduct,
    createBusinessProduct,
    updateBusinessProduct,
    setProduct2Edit,
    setOpenEdit,
    deleteBusinessProduct,
    setSelectedProducts,
    selectedProducts, 
    productsBusiness,
    productsWithBusiness,
    product2Edit,
    openEdit
  };

}
